import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RequestAction, MenuAction } from 'src/app/core/models/calendar.model';

@Component({
  selector: 'app-button-list',
  templateUrl: './buttons-list.component.html',
  styleUrls: ['./buttons-list.component.scss']
})

export class ButtonsListComponent {

  @Input() public indexId = null;
  @Input() public listActions: MenuAction [] = [];
  @Output() public sendAction = new EventEmitter<RequestAction>();


  public actionItem(index: number): void {
    this.indexId = index;
    this.listActions.forEach((x: MenuAction, i: number) => {
      if (index === i) {
        x.select = true;
      } else {
        x.select = false;
      }
    });
    this.sendAction.emit({index, list: this.listActions});
  }
  
 
}